import { useEffect, useState } from 'react';
import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Collapse,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { getTournamentTeams } from '../../../services/tournament.service';

const headerSx = {
  background: '#565656',
  color: '#e2e8f0',
  fontWeight: 700,
  letterSpacing: 0.5,
};

const cellSx = {
  background: '#9295a9',
  color: '#1a1f2e',
  fontWeight: 500,
  borderBottom: '1px solid rgba(0,0,0,0.15)',
};

const TeamRow = ({ team }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow hover onClick={() => setOpen(!open)} style={{ cursor: 'pointer' }}>
        <TableCell sx={{ ...cellSx, width: 50, textAlign: 'center', color: '#1a1f2e', padding: '4px' }}>
          {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
        </TableCell>
        <TableCell sx={{ ...cellSx, fontWeight: 700, textAlign: 'center' }}>
          {team.posicion ?? '—'}
        </TableCell>
        <TableCell sx={cellSx}>{team.nombre}</TableCell>
        <TableCell sx={{ ...cellSx, textAlign: 'center' }}>
          {team.puntos ?? '—'}
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, background: '#2c2e38' }} colSpan={4}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 2, padding: 2, background: '#1c1f26', border: '1px solid rgba(255,255,255,0.08)' }}>
              {team.jugadores && team.jugadores.length > 0 ? (
                <Table size="small" sx={{ width: '100%' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ background: '#3b3e4a', color: '#e2e8f0', fontWeight: 600, width: 40, borderBottom: 'none' }}>#</TableCell>
                      <TableCell sx={{ background: '#3b3e4a', color: '#e2e8f0', fontWeight: 600, borderBottom: 'none' }}>Jugador</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {team.jugadores.map((player, idx) => (
                      <TableRow key={idx}>
                        <TableCell sx={{ background: '#22252c', color: '#e2e8f0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                          {idx + 1}
                        </TableCell>
                        <TableCell sx={{ background: '#22252c', color: '#e2e8f0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                          {player.apellido_nombre}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              ) : (
                <Typography variant="body2" sx={{ color: '#9aa5b4', fontStyle: 'italic' }}>
                  No hay jugadores registrados en este equipo.
                </Typography>
              )}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

const TournamentTeams = ({ torId }) => {
  const [teams, setTeams] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    const fetchTeams = async () => {
      setIsLoading(true);
      try {
        const data = await getTournamentTeams(torId);
        setTeams(data);
      } catch (e) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    };
    fetchTeams();
  }, [torId]);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress sx={{ color: '#7c8cf8' }} />
      </Box>
    );
  }

  if (isError) {
    return (
      <Typography color="error" sx={{ py: 3 }}>
        Error al cargar los equipos.
      </Typography>
    );
  }

  if (!teams.length) {
    return (
      <Typography sx={{ color: '#9aa5b4', py: 3 }}>
        No hay equipos inscriptos en este torneo.
      </Typography>
    );
  }

  return (
    <TableContainer
      component={Paper}
      elevation={0}
      sx={{
        borderRadius: 0,
        border: '1px solid rgba(255,255,255,0.08)',
        background: 'transparent',
      }}
    >
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ ...headerSx, width: 50, textAlign: 'center' }}></TableCell>
            <TableCell sx={{ ...headerSx, width: 70, textAlign: 'center' }}>Pos.</TableCell>
            <TableCell sx={headerSx}>Nombre del Equipo</TableCell>
            <TableCell sx={{ ...headerSx, width: 100, textAlign: 'center' }}>Puntos</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {teams.map((t, idx) => (
            <TeamRow key={idx} team={t} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TournamentTeams;
